import { Flex } from "@chakra-ui/react";
import InboxHeader from "./InboxHeader/InboxHeader";
import TaskList from "./InboxBody/TaskList";
import { InboxActiveTab, inboxActiveTab } from "../../types/inbox/enum";
import { pxToRem } from "../../utils/styles/size";
import { DEFAULT_INBOX_ACCORDION, ToggleVisibility } from "../../types/inbox/type";
import { usePreference } from "../../hooks/preference/usePreference";
import { juneTrack } from "../../utils/june/analytics";
import { JUNE_EVENT, JUNE_LOCATION } from "../../hooks/june/juneEvent";

export type HandleTabToggleVisibility = (
  toggle: keyof ToggleVisibility,
  activeTab: InboxActiveTab
) => void;

/**
 * @param {object} props
 * @param {boolean} props.hasBlocksSynchronizedWithGoogle - 백엔드가 보내는 block들과 Google Calendar 동기화 여부
 */
export function TaskInbox({
  hasBlocksSynchronizedWithGoogle,
}: {
  hasBlocksSynchronizedWithGoogle: boolean;
}) {
  const { preference: userPreference, updatePreference } = usePreference();

  const inboxHeaderTab = userPreference?.inboxActiveTab ?? inboxActiveTab.INBOX;
  const inboxAccordion = userPreference?.inboxAccordion ?? DEFAULT_INBOX_ACCORDION;

  const handleToggleVisibility: HandleTabToggleVisibility = (toggle, activeTab) => {
    const newState = {
      ...inboxAccordion,
      [activeTab]: {
        ...inboxAccordion[activeTab],
        [toggle]: !inboxAccordion[activeTab][toggle],
      },
    };

    updatePreference({ inboxAccordion: newState });
  };

  const handleChangeActiveTab = (event: React.MouseEvent<HTMLButtonElement>) => {
    const tab = event.currentTarget.value as InboxActiveTab;
    updatePreference({ inboxActiveTab: tab });

    const currentLocation =
      tab === inboxActiveTab.INBOX ? JUNE_LOCATION.INBOX : JUNE_LOCATION.TODAY_INBOX;
    juneTrack(JUNE_EVENT.CHANGE_INBOX_TYPE, { location: currentLocation });
  };

  return (
    <Flex
      w={"100%"}
      h={"full"}
      flexDir={"column"}
      border={"1px solid"}
      borderColor={"rgba(255, 255, 255, 0.04)"}
      borderRadius={pxToRem(8)}
      backgroundColor={"#1B1C1D"}
      userSelect="none"
      sx={{
        "& > *": {
          // 자식 요소들에 대한 스타일
          userSelect: "none",
          "--user-drag": "none",
          WebkitUserDrag: "none",
        },
      }}
    >
      <InboxHeader
        handleChangeActiveTab={handleChangeActiveTab}
        activeTab={inboxHeaderTab}
        onToggleVisibility={handleToggleVisibility}
        toggleVisibility={inboxAccordion}
        hasBlocksSynchronizedWithGoogle={hasBlocksSynchronizedWithGoogle}
      />

      <TaskList
        toggleVisibility={inboxAccordion}
        activeTab={inboxHeaderTab}
        hasBlocksSynchronizedWithGoogle={hasBlocksSynchronizedWithGoogle}
      />
    </Flex>
  );
}
